module.exports = __webpack_public_path__ + "static/media/blog2_big.0d6b28c5.webp";